// extracted by mini-css-extract-plugin
export default {"wrapper":"Labeling_wrapper__3SIO8"};